import { render, staticRenderFns } from "./insurer-plan-document.vue?vue&type=template&id=c45e8674&scoped=true&"
import script from "./insurer-plan-document.vue?vue&type=script&lang=js&"
export * from "./insurer-plan-document.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plan-document.vue?vue&type=style&index=0&id=c45e8674&lang=scss&scoped=true&"
import style1 from "./insurer-plan-document.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45e8674",
  null
  
)

export default component.exports